import React,{useState,useEffect} from 'react';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import{Box,Button,Grid,Tooltip,Typography} from '@mui/material';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import { CreateKeyResult } from '../../Forms/CreateKeyResult/CreateKeyResult';
import { EditKeyResult } from '../../Forms/EditKeyResult/EditKeyResult';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetObjectiveDetails } from '../../Hooks';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import {CircularProgress} from '@mui/material';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CalculateIcon from '@mui/icons-material/Calculate';
import ScaleIcon from '@mui/icons-material/Scale';
import DescriptionIcon from '@mui/icons-material/Description';
import ODetailsTabs from '../ODetailsTabs/ODetailsTabs';
// import {useGetPersonPicture } from '../../../CompanyManagment/Hooks/index';
// import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
// import PersonIcon from '@mui/icons-material/Person';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import { useGetAllPersonPictureByTenantId } from '../../../AllTenantOkrs/Hooks';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
const Kr = () => {
  const navigate=useNavigate()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
const[showCreateKr,setShowCreateKr]=useState<Boolean|null>(false);
const[objectiId,setObjectiId]=useState<string|null>(null);
const{data:objData,isLoading,refetch:getObjDataAgain}=useGetObjectiveDetails(objectiId);
const[objectiveDetails,setObjectiveDetails]=useState<any>(null);
const[keyResults,setKeyResults]=useState<any>([])
const location:any=useLocation();
const[showToastMessage,setShowToastMessage]=useState<boolean>(false);
const[showToastMessage3,setShowToastMessage3]=useState<boolean>(false);
const[addKrState,setAddKrState]=useState<any>(null);
const[showEditKr,setShowEditKr]=useState<boolean>(false);
const[krId,setKrId]=useState<string|null>(null);
const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
const personId=useSelector((state:any)=>state.loign.personId);
const{data:personPicture,isLoading:loadingg}=useGetAllPersonPictureByTenantId(tenantId);
// const{data:personPictureData}=useGetPersonPicture(personId);
const[imgSrc,setImgSrc]=useState<any>(null);
let body:any={

  personId:personId
};

useEffect(() => {
console.log(krId)
if (krId) {
  setShowEditKr(true)
}
}, [krId])

    useEffect(() => {
    if (location) {
      let{state:{objectiveId}}:any=location;
      setObjectiId(objectiveId)
    }
    }, [])

    useEffect(() => {
      
   if (objData) {
    let{name,createByName,objectivesStateName,
      periodName,definitionLevelName,definitionLevelId,
      keyResultQueryResultDtos,calculateProgressType,
      weight,answerRequest,description,calculateProgressTypeValue,
      responsibleName,pictureBase64String,id
    }=objData;
      setKeyResults(keyResultQueryResultDtos)
    let objjjdata={
      name:name,
      createByName:createByName,
      objectivesStateName:objectivesStateName,
      periodName:periodName,
      definitionLevelName:definitionLevelName,
      definitionLevelId:definitionLevelId,
      keyResultQueryResultDtosLength:keyResultQueryResultDtos?.length,
      keyResultQueryResultDtos:keyResultQueryResultDtos,
      calculateProgressType:calculateProgressType,
      calculateProgressTypeValue:calculateProgressTypeValue,
      weight:weight,
      answerRequest:answerRequest,
      description:description,
      responsibleName:responsibleName,
      objectiveId:id,
      id : id
    }
    setObjectiveDetails(objjjdata)
   }
    }, [objData])
    
      
  useEffect(() => {
    
    if (objData) {
      let{pictureBase64String}=objData;
      setImgSrc(pictureBase64String)
    }
      }, [objData]) 

const initialCreateKr=():void=>{
    setShowCreateKr(prev=>!prev)
  }

  const initialGoBack=()=>{
    navigate('/dashboard/okrManagment',{replace:true,state:{objectiveId:''}})
  }
  return (
    <>
    <Grid container  >
    <Grid item xs={12}  >
     <Box width={'100%'} boxShadow={1}
     py={2} 
     px={1} 
     display={'flex'} 
     justifyContent={'space-between'}
     flexDirection={'row-reverse'} >
     <Box>
     <DyButton  
    caption={'ایجاد نتیجه کلیدی'}
    onClick={initialCreateKr}
    disbled={false}
    variant={'contained'}
    type={'button'}
    bgColor={'#00387C'}
    />
     </Box>
     <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
  <Typography fontSize={{ xs: '12px', sm: '14px' }} fontWeight={600}>
    جزئیات هدف و نتیجه ی کلیدی
  </Typography>
</Box>

     <Box>
      <Button variant='text' onClick={initialGoBack} startIcon={<ArrowForwardIcon/>}   >
        برگشت
      </Button>
     </Box>
     </Box>
    </Grid>

    <Grid item xs={12}  >
     {
    isLoading && <Box py={4}  textAlign={'center'}   >
      <CircularProgress/>
    </Box>
     }
     {
      !isLoading && <Grid container >
     <Grid item xs={12} px={1} >
     <Box width={'100%'}  py={5} bgcolor={'#00387C'} borderRadius={3}  >
       <Grid container  >
        <Grid item xs={12}  sx={{position:'relative'}}  >
       <Grid container 
      bgcolor={'#f9f9f9'}
       width={'90%'} 
       sx={{position:'absolute',top:'20px',mx:'auto',transform: 'translate(-50%, -50%)',left: '50%',}} 
       display={'flex'} justifyContent={'space-between'}  
       borderRadius={2}
       boxShadow={4}
       >
       <Grid item xs={6} sm={9}>
       <Box p={1}  >
       <Typography variant='body1' fontWeight={800} fontSize={{ xs: '11px', sm: '13px' }} >
          {
            objectiveDetails?.name
          }
        </Typography>
       </Box>
      </Grid>

       <Grid item xs={6} sm={3}>
     <Box display={'flex'}   p={1} flexDirection={'row-reverse'} justifyContent={'start'}>
     <Box display={"flex"}   flexDirection={"row-reverse"} alignItems={"center"} textAlign={"center"}>
     <img src={
                  personPicture !== null && personPicture !== undefined &&
                  personPicture.filter((x:any)=>x.personId ===  objectiveDetails?.responsibleId)[0] !== null &&
                  personPicture.filter((x:any)=>x.personId ===  objectiveDetails?.responsibleId)[0]!== undefined
                  ?
                  personPicture.filter((x:any)=>x.personId ===  objectiveDetails?.responsibleId)[0].pictureBase64String
                  :''
                } width={'25px'} style={{borderRadius:'50%'}} />
        <Typography variant='body1' px={1} fontWeight={800} textAlign={'center'}                  
         fontSize={{ xs: '11px', sm: '13px' }}
        >
        {objectiveDetails?.responsibleName}
        </Typography>
        </Box>
        </Box>
     </Grid>

     <Grid item xs={6} sm={8}>
     <Box px={1}>
           <Typography variant='body2' fontWeight={700}                   fontSize={{ xs: '11px', sm: '13px' }}
           >
          {
            objectiveDetails?.objectivesStateName
          }
          </Typography>
    </Box>
     </Grid>
     <Grid item xs={6} sm={3}>
     <Box px={1} >
            <Typography variant='body2' fontWeight={700}                   fontSize={{ xs: '11px', sm: '13px' }}
            >
           دوره زمانی: 
           {
               objectiveDetails?.periodName
            }
          </Typography>
          
         </Box>
     </Grid>

     <Grid item xs={6} sm={3}>
     <Box display={'flex'} justifyContent={'start'} px={1} py={1} >
        {
          objectiveDetails?.keyResultQueryResultDtos.filter((x:any) => x.okrStateName === 'فعال').length < 3 ?<Typography color={'red'} fontSize={{ xs: '11px', sm: '13px' }} fontWeight={900} variant='caption'  >تعداد نتایج کلیدی شما کمتر از 3 است</Typography>:
          objectiveDetails?.keyResultQueryResultDtos.filter((x:any) => x.okrStateName === 'فعال').length > 5 ?<Typography color={'red'} fontSize={{ xs: '11px', sm: '13px' }} fontWeight={900} variant='caption'  >تعداد نتایج کلیدی شما بیشتر از 5 است</Typography>:
          ''
        }
       </Box>
       </Grid>

       <Grid item xs={6} sm={3}>
       <Box width={'100%'} px={1} py={1} >
    <Typography variant='body2' fontWeight={900} fontSize={{ xs: '11px', sm: '13px' }}>
      نام تیم:
      {
        objectiveDetails?.definitionLevelName
      }
    </Typography>
    </Box> 
       </Grid>
       </Grid>
        </Grid>
       </Grid>
     </Box>
     </Grid>

     <Grid item xs={12} mt={4}>
  <Grid container px={1} spacing={2} direction={{ xs: 'column', sm: 'row' }}>
    <Grid item xs={12} sm={3}>
      <Box width="100%" display="flex" justifyContent="start" p={1}>
        <Box>
          <VisibilityIcon />
        </Box>
        <Box>
          <Typography
            variant="caption"
            fontWeight={700}
            px={1}
            fontSize={{ xs: '12px', sm: '13px' }}
          >
            قابلیت نمایش
          </Typography>
        </Box>
      </Box>
      <Box
        width={{ xs: '100%', sm: '80%' }}
        bgcolor="#f9f9f9"
        display="flex"
        justifyContent="start"
        borderRadius={3}
        boxShadow={1}
        p={2}
      >
        <Typography
          variant="caption"
          fontSize={{ xs: '12px', sm: '13px' }}
          fontWeight={400}
        >
          قابلیت نمایش برای همه
        </Typography>
      </Box>
    </Grid>

    {/* نحوه محاسبه پیشرفت */}
    <Grid item xs={12} sm={3}>
      <Box width="100%" display="flex" justifyContent="start" p={1}>
        <Box>
          <CalculateIcon />
        </Box>
        <Box>
          <Typography
            variant="caption"
            fontWeight={700}
            px={1}
            fontSize={{ xs: '12px', sm: '13px' }}
          >
            نحوه محاسبه پیشرفت
          </Typography>
        </Box>
      </Box>
      <Box
        width={{ xs: '100%', sm: '80%' }}
        bgcolor="#f9f9f9"
        display="flex"
        justifyContent="start"
        borderRadius={3}
        boxShadow={1}
        p={2}
      >
        <Typography
          variant="caption"
          fontSize={{ xs: '12px', sm: '13px' }}
          fontWeight={400}
        >
          {objectiveDetails?.calculateProgressTypeValue}
        </Typography>
      </Box>
    </Grid>

    {/* وزن */}
    <Grid item xs={12} sm={3}>
      <Box width="100%" display="flex" justifyContent="start" p={1}>
        <Box>
          <ScaleIcon />
        </Box>
        <Box>
          <Typography
            variant="caption"
            fontWeight={700}
            fontSize={{ xs: '12px', sm: '13px' }}
            px={1}
          >
            وزن
          </Typography>
        </Box>
      </Box>
      <Box
        width={{ xs: '100%', sm: '80%' }}
        bgcolor="#f9f9f9"
        display="flex"
        justifyContent="start"
        borderRadius={3}
        p={2}
        boxShadow={1}
      >
        <Typography
          variant="caption"
          fontWeight={400}
          fontSize={{ xs: '12px', sm: '13px' }}
        >
          {objectiveDetails?.weight}
        </Typography>
      </Box>
    </Grid>

    {/* دلیل اهمیت */}
    <Grid item xs={12} sm={3}>
      <Box width="100%" display="flex" justifyContent="start" p={1}>
        <Box>
          <CrisisAlertIcon />
        </Box>
        <Box>
          <Typography
            variant="caption"
            fontWeight={700}
            fontSize={{ xs: '12px', sm: '13px' }}
            px={1}
          >
            دلیل اهمیت
          </Typography>
        </Box>
      </Box>
      <Box>
        <Box
          display="flex"
          width={{ xs: '100%', sm: '80%' }}
          height="50px"
          bgcolor="#f9f9f9"
          justifyContent="start"
          borderRadius={3}
          p={2}
          boxShadow={1}
        >
          {objectiveDetails?.answerRequest.length > 40 ? (
            <Tooltip
              sx={{ fontSize: '1.5rem !important' }}
              title={objectiveDetails?.answerRequest}
            >
              <Typography
                px={1}
                variant="body1"
                sx={{
                  fontSize: '12px !important',
                  fontWeight: '400',
                  color: 'black',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                {objectiveDetails?.answerRequest.slice(0, 40)}
              </Typography>
            </Tooltip>
          ) : (
            <Typography
              px={1}
              sx={{
                fontSize: '12px !important',
                fontWeight: '400',
                color: 'black',
                cursor: 'pointer',
                textAlign: 'left',
              }}
            >
              {objectiveDetails?.answerRequest}
            </Typography>
          )}
        </Box>
      </Box>
    </Grid>
  </Grid>
</Grid>


     {/* <Grid item xs={11}>
    <Box px={1} >
      
    <Box  width={'100%'}  display={'flex'} justifyContent={'start'} p={1} >
       <Box>
        <DescriptionIcon/>
        </Box>
       <Box>
       <Typography variant='caption' fontSize={'13px'}fontWeight={700} px={1}>توضیحات</Typography>
       </Box>
      </Box>
      <Box 
      width={'80%'} bgcolor={'#f9f9f9'} 
      display={'flex'} justifyContent={'start'} 
      borderRadius={3}
      p={2} boxShadow={1}
      >
      <Box display={'flex'}>
      {
        objectiveDetails?.description === '' ? 'هنوز تعریف نشده' :
        objectiveDetails?.description.length > 130 ?
          <Tooltip
            sx={{ fontSize: '1.5rem !important' }}
            title={objectiveDetails?.description === '' ? 'هنوز تعریف نشده' : objectiveDetails?.description}
          >
            <Typography
              px={1}
              variant='body1'
              sx={{ fontSize: '12px !important', fontWeight: '400', color: 'black', cursor: 'pointer', textAlign: 'left' }}
            >
              {objectiveDetails?.description === '' ? 'هنوز تعریف نشده' : objectiveDetails?.description.slice(0, 130)}
            </Typography>
          </Tooltip>
        :
          <Typography
            px={1}
            sx={{ fontSize: '12px !important', fontWeight: '400', color: 'black', textAlign: 'left' }}
            dangerouslySetInnerHTML={{ __html: objectiveDetails?.description || '' }}
          />
      }
    </Box>
     {/* <Typography variant='caption' fontSize={'12px'} fontWeight={400} >{objectiveDetails?.description===''?'هنوز تعریف نشده':objectiveDetails?.description}</Typography> */}
       {/* </Box>
    </Box>

     </Grid> */} 
         <Grid item xs={isMobile ? 12 : 11}> 
      <Box px={isMobile ? 0 : 1} width="100%">
        <Box width="100%" display="flex" justifyContent="start" p={1}>
          <Box>
            <DescriptionIcon />
          </Box>
          <Box>
            <Typography variant="caption" fontSize="13px" fontWeight={700} px={1}>
              توضیحات
            </Typography>
          </Box>
        </Box>
        <Box
          width={isMobile ? '100%' : '80%'} 
          bgcolor="#f9f9f9"
          display="flex"
          justifyContent="start"
          borderRadius={3}
          p={2}
          boxShadow={1}
        >
          <Box display="flex">
            {objectiveDetails?.description === '' ? 'هنوز تعریف نشده' :
              objectiveDetails?.description.length > 130 ? (
                <Tooltip
                  sx={{ fontSize: '1.5rem !important' }}
                  title={objectiveDetails?.description === '' ? 'هنوز تعریف نشده' : objectiveDetails?.description}
                >
                  <Typography
                    px={1}
                    variant="body1"
                    sx={{
                      fontSize: '12px !important',
                      fontWeight: '400',
                      color: 'black',
                      cursor: 'pointer',
                      textAlign: 'left',
                    }}
                  >
                    {objectiveDetails?.description.slice(0, 130)}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography
                  px={1}
                  sx={{
                    fontSize: '12px !important',
                    fontWeight: '400',
                    color: 'black',
                    textAlign: 'left',
                  }}
                  dangerouslySetInnerHTML={{ __html: objectiveDetails?.description || '' }}
                />
              )}
          </Box>
        </Box>
      </Box>
    </Grid>
       <Grid item xs={12}  >
       <ODetailsTabs 
        krs={keyResults} 
        setKrId={setKrId}
        setShowEditKr={setShowEditKr}
        setAddKrState={setAddKrState}
        personPicture={personPicture}
        setShowToastMessage={setShowToastMessage}
       />
       </Grid>
      </Grid>
     }
    </Grid>
{/*  objectivesStateName:objectivesStateName,
      periodName:periodName */}
    {
      showCreateKr && <ModalLyt   
      showModal={showCreateKr}
      setShowModal={setShowCreateKr}
      width={isMobile ? '350px' : '1200px'}  
      title={'ایجاد نتیجه کلیدی'}  >
       <CreateKeyResult 
       setShowCreateKr={setShowCreateKr}
       addKrSuccess={getObjDataAgain}  
       definitionId = {objectiveDetails?.definitionLevelId}
       objectiveId = {objectiveDetails?.id}
       periodId = {objData?.periodId}
       setShowToastMessage={setShowToastMessage}
       setAddKrState={setAddKrState}
        />
      </ModalLyt>
    }
    {
      showEditKr && <ModalLyt 
      // height={1100} 
      showModal={showEditKr}
      setShowModal={setShowEditKr}
      width={isMobile ? '350px' : '1200px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
      title={'ویرایش نتیجه کلیدی'}
      >
      <EditKeyResult  
      definitionId = {objectiveDetails?.definitionLevelId}
      setShowEditKeyResult={setShowEditKr}
      editKrSuccess={getObjDataAgain}  
      setShowToastMessage={setShowToastMessage}
      setShowToastMessage3={setShowToastMessage3}
      setAddKrState={setAddKrState}
      krId={krId}
      Item={objectiveDetails}
      />
      </ModalLyt>
    }
    {
      showToastMessage && <DYToastMessage
      isSuccess={addKrState?.isSuccess}
      message={addKrState?.metaData.message}
      setShow={setShowToastMessage}
      show={showToastMessage}
      />      
    }
    {
      showToastMessage3 && (
      <DYToastMessage
        isSuccess={true}
        message={'عملیات با موفقیت انجام شد'}
        setShow={setShowToastMessage3}
        show={showToastMessage3}
      />
    )}
    </Grid>
    </>
  )
}

export default Kr